<template>
  <main id="container">
    <!-- 메인 비주얼 -->
    <!-- <main-visual /> -->

    <div class="msection-wrap">
      <!--메인 배너 (PC/모바일 분기)-->
      <main-banner v-if="!isMobile" />
      <mobile-banner v-else />

      <!-- 황금녘 동행축제 안내 및 영상  -->
      <!-- <main-info-video /> -->

      <!-- 동행축제 이야기 -->
      <!-- <main-festa-show /> -->

      <!-- 동행뉴스
        date : '2025.02.10
        redmine : https://pms.fanfandaero.kr/issues/30663 -->
      <!-- <main-default-news /> -->

      <!-- 동행축제 실시간 찜하기 -->
      <!--
        date : '2025.02.10
        **3월 동행축제에서만 제외
        redmine : https://pms.fanfandaero.kr/issues/30663
      <main-realtime-dibs />-->
      <main-realtime-dibs />
      <!-- 상생 할인전 -->
      <!-- <main-winwin-exhibition /> -->
    </div>
  </main>
</template>
<script>
import { mapGetters } from "vuex";
import MainVisual from "@/components/main/MainVisual";
import MainInfoVideo from "@/components/main/MainInfoVideo";
import MainFestaShow from "@/components/main/MainFestaShow";
import MainRealtimeDibs from "@/components/main/MainRealtimeDibs";
import MainWinwinExhibition from "@/components/main/MainWinwinExhibition";
import MainDefaultNews from "@/components/main/MainDefaultNews.vue";
import MainBanner from "@/components/Banner.vue";
import MobileBanner from "@/components/MobileBanner.vue";

export default {
  name: "Main",
  components: {
    MainDefaultNews,
    MainVisual,
    MainInfoVideo,
    MainFestaShow,
    MainRealtimeDibs,
    MainWinwinExhibition,
    MainBanner,
    MobileBanner,
  },
  computed: {
    ...mapGetters("auth", ["session", "isAuth"]),
    ...mapGetters("common", ["isMobile", "returnRoute"]),
  },
  watch: {},
  props: {},
  data: () => ({}),
  created() {},
  beforeDestroy() {},
  mounted() {},
  methods: {},
  destroyed() {},
};
</script>
